// extracted by mini-css-extract-plugin
export var messageSideLeft = "_or-1";
export var stateContainer = "_or-0";